<template>
    <v-dialog max-width="500" v-model="visible" persistent>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" > Ambiente: {{$store.state.ambiente.id}}</v-btn>
        </template>
            
        <v-card dense>
            <v-toolbar color="success" dark>
                <v-toolbar-title>Selección de Ambiente de Trabajo</v-toolbar-title>
            </v-toolbar >

            <v-card-text>
                <v-container >
                        
                        <template v-for="ambiente in $store.state.ambientes">
                            <v-row  :key="ambiente.id" no-gutters>
                                <v-col xs12>
                                    <v-alert dense :color="$store.state.ambiente.id == ambiente.id?'success':''" >
                                        <v-switch :dark="$store.state.ambiente.id == ambiente.id" dense 
                                            :label="ambiente.id" :value="$store.state.ambiente.id == ambiente.id" @click="set(ambiente)"></v-switch>
                                    </v-alert>
                                </v-col>
                            </v-row>                        
                        </template>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="visible=false"><v-icon>save</v-icon>&nbsp;Establecer Ambiente</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data () {
    return {
      temaOscuro: false,
      visible: false,
      mostrarTareasFrecuentes: false,
      mostrarRecordatorios: false,
      empresaPredeterminadaId: 0,
      canalVentaPredeterminadoId: 0,
      numeroInterno:null,
      debugModeOn: false,
      empresas: [],
      canalesVenta: [],
      busquedaPersonaPor: 'Documento',
      opcionesBusquedaPersonas:['Documento', 'Cuil', 'Nombre', 'Operación'],
      carCode: ''
    }
  },
  props:{     
    userName: {
      type: String,
      default: ''
    },    
  },
  created () {
      if(!this.ambiente){
            // si no hay un ambiente, seteo el primero o producción
          if(this.$store.state.ambientes.length > 0){
              // veo si está el de producción
              if(this.$store.state.ambientes.find(a=>a.id =='Producción'))                
                this.setAmbiente( this.$store.state.ambientes.find(a=>a.id =='Producción'));
              else
                this.setAmbiente( this.$store.state.ambientes[0]);
          }          
      }
  },
  watch: {
      'visible'(){
           if(this.visible){
             
           }
      },
       'debugModeOn'(){
           this.setDebugMode(this.debugModeOn)
       }
  },
  computed:{
    ...mapGetters(['UiCustomUserSettings', 'user', 'DebugModeOn','ParametrosGenerales', 'ambiente', 'isProduction']),
  },
  methods: {
    //...mapMutations(['setUiCustomUserSettings']),
    ...mapActions([ "setAmbiente"]),
    ...mapMutations(["setDebugMode","alertClear", "alertSuccess", "alertWarning", "alertError"]), 
    
    async set(ambiente){
        this.setAmbiente(ambiente);
    },

  }
}
</script>